import PropTypes from 'prop-types';
import React, { createContext, useRef } from 'react'

export const AccordionRegistryContext = createContext();

/**
 * Accordion Registry Provider
 * 
 * This provider maintains a registry of accordion sections and their fields.
 * It allows components to register and unregister accordion sections, and provides
 * access to the current registry.
 */
const AccordionRegistryProvider = ({ children }) => {
  const registryRef = useRef({});

  const register = (id, fields) => {
    registryRef.current[id] = { fields };
  }

  const unregister = (id) => {
    delete registryRef.current[id];
  }

  const getRegistry = () => registryRef.current;

  const value = {
    register,
    unregister,
    getRegistry,
  }

  return (
    <AccordionRegistryContext.Provider value={value}>
      {children}
    </AccordionRegistryContext.Provider>
  );
}

AccordionRegistryProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AccordionRegistryProvider;